export const surfaceConstants = {
  TOGGLEDRAWER: "DRAWER_TOGGLE",
  SETTITLE: "PAGE_SETTITLE",
  LEFT_DRAWER_REQUIRED: "LEFT_DRAWER_REQUIRED",
  SHOW_HEADER_SEARCH_BAR: "SHOW_HEADER_SEARCH_BAR",
  SET_SEARCH_FUNC: "SET_SEARCH_FUNC"
};
